import { Size } from '../../model';
import { ConditionalDynamicDisplayElement } from '../base/conditional-dynamic-display-element';
export class PolyLineElement extends ConditionalDynamicDisplayElement {
    constructor(element, permissionChecker, variableCommunicator, variableStore) {
        super(element, permissionChecker, variableCommunicator, variableStore);
    }
    getActualSize() {
        const arcPath = Snap(this.$element.find('path')[0]);
        const b = arcPath.getBBox(true);
        return new Size(b.width, b.height);
    }
    getActualLocation() {
        const x = this.model.location.x;
        const y = this.model.location.y;
        return {
            x, y
        };
    }
}
